import React, { useContext, useState } from 'react';
import { PermissionEditorSetAndGetPermissions } from './PermissionEditorSetAndGetPermissions';
import Drawer from '@atlaskit/drawer';
import Button from '@atlaskit/button';
import { GlobalContext } from 'shared-components/common/GlobalContext';
import styled from '@emotion/styled';
import Tooltip from '@atlaskit/tooltip';
import PeopleIcon from '@atlaskit/icon/glyph/people';
import { CepHelpDialog } from 'shared-components/stateless/CepHelpDialog';
import { token } from '@atlaskit/tokens';

const DrawerHeadlineContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
const DrawerHeadlineAction = styled.div`
  margin-right: 8px;
`;
const DrawerHeadline = styled.div`
  font-size: 20px;
  padding-left: 8px;
`;
const DrawerSubHeadline = styled.div`
  font-size: 12px;
  padding-left: 8px;
  margin-bottom: 10px;
`;

export const PermissionEditorEditPermissions = ({
  isGlobal,
  fieldId,
  fieldName,
  contextId,
  contextName,
  isDisabled,
}: {
  isGlobal: boolean;
  fieldId: string;
  fieldName: string;
  contextId: number | null;
  contextName: string;
  isDisabled: boolean;
}) => {
  const { t } = useContext(GlobalContext);

  const [isOpen, setOpen] = useState<boolean>(false);
  return (
    <div>
      <Drawer testId="x" onClose={() => setOpen(false)} isOpen={isOpen} width={'wide'}>
        <DrawerHeadlineContainer>
          <DrawerHeadline>
            {t('permissions.headline')} {fieldName}
          </DrawerHeadline>
          <DrawerHeadlineAction>
            <CepHelpDialog
              helpContent={
                <>
                  {isGlobal && <p>{t('editPermissionsPage.globalPermissions.notice.paragraph1')}</p>}
                  {isGlobal && (
                    <ul>
                      <li>{t('editPermissionsPage.globalPermissions.notice.paragraph2')}</li>
                    </ul>
                  )}
                  {!isGlobal && (
                    <>
                      <p>{t('editPermissionsPage.contextPermissions.notice.paragraph1')}</p>
                      <ul>
                        <li>{t('editPermissionsPage.contextPermissions.notice.paragraph2')}</li>
                        <li>{t('editPermissionsPage.contextPermissions.notice.paragraph3')}</li>
                      </ul>
                    </>
                  )}
                </>
              }
              helpUri={isGlobal ? '/admin-guide/permission-editor/#global' : '/admin-guide/permission-editor/#context'}
            />
          </DrawerHeadlineAction>
        </DrawerHeadlineContainer>
        <DrawerSubHeadline>
          {isGlobal ? (
            <>{t('permissions.globalPermission')}</>
          ) : (
            <>
              {t('permissions.contextPermission')}: {contextName}
            </>
          )}
        </DrawerSubHeadline>
        <PermissionEditorSetAndGetPermissions fieldId={fieldId} contextId={contextId} />
      </Drawer>
      <Tooltip content={isGlobal ? t('permissions.editGlobalPermissions') : t('permissions.editContextPermissions')}>
        <Button
          iconBefore={
            isGlobal ? (
              <PeopleIcon label="edit global permissions" primaryColor={isDisabled ? token('color.text.disabled', '#ccc') : token('color.text.accent.blue.bolder', '#253858')} />
            ) : (
              <PeopleIcon label="edit context permission" primaryColor={isDisabled ? token('color.text.disabled', '#ccc') : token('color.text.accent.blue.bolder', '#253858')} />
            )
          }
          onClick={() => setOpen(true)}
          appearance="subtle"
          isDisabled={isDisabled}
        />
      </Tooltip>
    </div>
  );
};
